enum EventCategory {
  AUTH = 'auth',
  PROGRAM = 'program',
  PROGRAM_TEMPLATE = 'program_template',
  PARTICIPANT = 'participant',
  USER = 'user',
}

export default EventCategory;
